export default __webpack_public_path__ + "static/media/05_QandA.d07aa69e.png";